import { render } from "./ProductSelector.vue?vue&type=template&id=28367e65"
import script from "./ProductSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductSelector.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/config-app/components/ProductSelector.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "28367e65"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('28367e65', __exports__)) {
    api.reload('28367e65', __exports__)
  }
  
  module.hot.accept("./ProductSelector.vue?vue&type=template&id=28367e65", () => {
    api.rerender('28367e65', render)
  })

}


export default __exports__